// import React from 'react';
// import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
// import Layout from './components/Layout';
// import DashboardLayout from './components/DashboardLayout';
// import StartLogin from './components/StartLogin';
// import LandingPage from './components/landingPage';
// import HomePage from './components/Homepage/index'
// import { UploadListing } from './components/pages/uploadListing';
// import { Listings } from './components/pages/listings';
// import { Bookings } from './components/pages/bookings';
// import AuthManager from './AuthManager';
// import { ErrorBoundary } from 'react-error-boundary';
// import { ErrorFallback } from './ErrorFallback';
// import { Register } from './components/pages/register';
// import { SettingsProfile } from './components/pages/profile';
// import { Provider } from 'react-redux'
// import { PersistGate } from 'redux-persist/integration/react'
// import store, { persistor } from './redux/store'
// import AuthRedirectCleaner from './AuthRedirectCleaner';
// import { AgentListingPage } from './components/pages/agentListingPage';
// import { ClerkProvider } from '@clerk/react'
// import ClerkTokenSetter from './ClerkTokenSetter';

// export const App = () => {
//     const providerConfig = {
//         domain: process.env.REACT_APP_AUTH0_DOMAIN,
//         clientId: process.env.REACT_APP_AUTH0_CLIENT_ID,
//         authorizationParams: {
//             redirect_uri: process.env.REACT_APP_REDIRECT_URI
//         },
//         cacheLocation: "localstorage"
//     }

//     const PUBLISHABLEKEY = process.env.REACT_APP_CLERK_PUBLISHABLE_KEY;
//     return (
//         <div>
//             <ErrorBoundary FallbackComponent={ErrorFallback}>
//                 <ClerkProvider publishableKey={PUBLISHABLEKEY} >
//                     <Provider store={store}>
//                         <PersistGate loading={null} persistor={persistor}>
//                             <AuthRedirectCleaner />
//                             <ClerkTokenSetter />
//                             <Router>
//                                 <Routes>
//                                     <Route path="/" element={<LandingPage />} />
//                                     <Route path="/LogIn" element={<StartLogin />} />

//                                     {/* Dashboard Layout (Sidebar + No Navbar) */}
//                                     <Route path="/" element={<DashboardLayout />}>
//                                         <Route path="/homepage" element={<HomePage />} />
//                                         <Route path="/pages/uploadlisting" element={<UploadListing />} />
//                                         <Route path="/pages/bookings" element={<Bookings />} />
//                                         <Route path="/pages/listings" element={<Listings />} />
//                                         <Route path="/pages/register" element={<Register />} />
//                                         <Route path="/pages/profile" element={<SettingsProfile />} />
//                                         <Route path="/pages/agentpage/:agentId" element={<AgentListingPage />} />
//                                     </Route>

//                                     {/* Legacy Layout (for pages that still need the old header) */}
//                                     <Route path="/" element={<Layout />}>
//                                     </Route>
//                                 </Routes>
//                             </Router>
//                         </PersistGate>
//                     </Provider>
//                 </ClerkProvider>
//             </ErrorBoundary>
//         </div>
//     )
// }



import React, { useState, lazy, Suspense } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Layout from './components/Layout';
const DashboardLayout = lazy(() => import('./components/DashboardLayout'));
import { ErrorBoundary } from 'react-error-boundary';
import { ErrorFallback } from './ErrorFallback';
import { Provider } from 'react-redux'
import { PersistGate } from 'redux-persist/integration/react'
import store, { persistor } from './redux/store'
import AuthRedirectCleaner from './AuthRedirectCleaner';
import { ClerkProvider } from '@clerk/react'
import ClerkTokenSetter from './ClerkTokenSetter';
import { useIdleSignOut } from './hooks/useIdleSignOut';
import SessionTimeoutDialog from './components/SessionTimeoutDialog';
import { Loading } from './utils/loading';
const HttpErrorOverlay = lazy(() => import('./components/HttpErrorOverlay').then(m => ({ default: m.HttpErrorOverlay })));
const ListingDetailPage = lazy(() => import('./components/pages/ListingDetailPage').then(m => ({ default: m.ListingDetailPage })));

const StartLogin = lazy(() => import('./components/StartLogin'));
const LandingPage = lazy(() => import('./components/landingPage'));
const HomePage = lazy(() => import('./components/Homepage/index'));
const UploadListing = lazy(() => import('./components/pages/uploadListing').then(m => ({ default: m.UploadListing })));
const LeadDetailPage = lazy(() => import('./components/pages/LeadDetailPage').then(m => ({ default: m.LeadDetailPage })));
const Listings = lazy(() => import('./components/pages/listings').then(m => ({ default: m.Listings })));
const Bookings = lazy(() => import('./components/pages/bookings').then(m => ({ default: m.Bookings })));
const MyEnquiries = lazy(() => import('./components/pages/MyEnquiries').then(m => ({ default: m.MyEnquiries })));
const Register = lazy(() => import('./components/pages/register').then(m => ({ default: m.Register })));
const SettingsProfile = lazy(() => import('./components/pages/profile').then(m => ({ default: m.SettingsProfile })));
const AgentListingPage = lazy(() => import('./components/pages/agentListingPage').then(m => ({ default: m.AgentListingPage })));
const ManageListing = lazy(() => import('./components/pages/manageListing').then(m => ({ default: m.ManageListing })));
const Earn = lazy(() => import('./components/pages/earn').then(m => ({ default: m.Earn })));
const AmbassadorLeads = lazy(() => import('./components/pages/leads').then(m => ({ default: m.AmbassadorLeads })));
const FavoritesPage = lazy(() => import('./components/pages/FavoritesPage'));
const WalletPage = lazy(() => import('./components/pages/WalletPage').then(m => ({ default: m.WalletPage })));
const SignInPage = lazy(() => import('./components/auth/SignInPage'));
const SignUpPage = lazy(() => import('./components/auth/SignUpPage'));
const EmailVerification = lazy(() => import('./components/auth/EmailVerification'));
const SSOCallback = lazy(() => import('./components/auth/SSOCallback'));
// import { ThemeProvider } from './context/ThemeContext';
// import { HttpErrorProvider } from './context/HttpErrorContext';
// import './Styles/DarkMode.scss';

export const App = () => {
    const PUBLISHABLEKEY = process.env.REACT_APP_CLERK_PUBLISHABLE_KEY;
    const [interceptorsReady, setInterceptorsReady] = useState(false)

    const IdleGuard = () => {
        const { status, secondsLeft, resetTimer } = useIdleSignOut()
        return (
            <SessionTimeoutDialog
                visible={status === 'warning'}
                secondsLeft={secondsLeft}
                onKeepAlive={resetTimer}
            />
        )
    }

    return (
        <div>
            <ErrorBoundary FallbackComponent={ErrorFallback}>
                <ClerkProvider publishableKey={PUBLISHABLEKEY}>
                    <Suspense fallback={null}><HttpErrorOverlay /></Suspense>
                    <Provider store={store}>
                        <PersistGate loading={null} persistor={persistor}>
                            {/* <ThemeProvider> */}
                                {/* <HttpErrorProvider> */}
                                    <AuthRedirectCleaner />
                                    <ClerkTokenSetter
                                        onReady={() => setInterceptorsReady(true)}
                                    />
                                    {interceptorsReady && (
                                        <Router>
                                            <Suspense fallback={<Loading />}>
                                            <Routes>
                                                <Route path="/" element={<LandingPage />} />
                                                <Route path="/LogIn" element={<StartLogin />} />
                                                <Route path="/sign-in" element={<SignInPage />} />
                                                <Route path="/sign-up" element={<SignUpPage />} />
                                                <Route path="/verify-email" element={<EmailVerification />} />
                                                <Route path="/sso-callback" element={<SSOCallback />} />

                                                <Route path="/" element={<DashboardLayout />}>
                                                    <Route path="/homepage" element={<HomePage />} />
                                                    <Route path="/pages/uploadlisting" element={<UploadListing />} />
<Route path="/pages/bookings" element={<Bookings />} />
                                                    <Route path="/pages/enquiries" element={<MyEnquiries />} />
                                                    <Route path="/pages/favorites" element={<FavoritesPage />} />
                                                    <Route path="/pages/listings" element={<Listings />} />
                                                    <Route path="/pages/listings/:listingId" element={<ManageListing />} />
                                                    <Route path="/pages/register" element={<Register />} />
<Route path="/pages/profile" element={<SettingsProfile />} />
                                                    <Route path="/pages/earn" element={<Earn />} />
                                                    <Route path="/pages/wallet" element={<WalletPage />} />
                                                    <Route path="/pages/leads" element={<AmbassadorLeads />} />
                                                    <Route path="/pages/leads/:leadId" element={<LeadDetailPage />} />
                                                    <Route path="/pages/agentpage/:agentId" element={<AgentListingPage />} />
                                                    <Route path="/pages/listing/:listingId" element={<ListingDetailPage />} />
                                                </Route>

                                                <Route path="/" element={<Layout />}>
                                                </Route>
                                            </Routes>
                                            </Suspense>
                                        </Router>
                                    )}
                                    <IdleGuard />
                                {/* </HttpErrorProvider> */}
                            {/* </ThemeProvider> */}
                        </PersistGate>
                    </Provider>
                </ClerkProvider>
            </ErrorBoundary>
        </div>
    )
}